// import { Form, Formik } from 'formik'
// import React, { useState } from 'react'
// import { Button, Modal } from 'react-bootstrap'
// import { TextBox } from '../../shared/controls/form'
// import apiServices from '../../services/service'
// import { toast } from 'react-toastify'

// const CampaignRegistrationPopup = ({showModal, handleCloseModal}) => {

//   const [formData, setFormData] = useState()
//   const [loading, setLoading] = useState(false)

//   const handleChangeForm = (e) => {
//   const { name, value } = e.target;
//   setFormData((prevData) => ({
//     ...prevData,
//     [name]: value,
//   }));
// };


// const handleSubmit = (formData) => {
//   setLoading(true);
//   apiServices
//     .getAccessToken(formData)
//     .then((response) => {
//       if (response.status === 200) {
//         setLoading(false);
//         const result = response.data;

//         // ✅ If it's a URL string, open it in a new tab
//         if (typeof result === "string" && result.startsWith("http")) {
//           window.open(result, "_blank");
//         } 
//         // ✅ If it's a file blob (like PDF), create a URL and open it
//         else if (result instanceof Blob) {
//           const blobUrl = URL.createObjectURL(result);
//           window.open(blobUrl, "_blank");
//         } 
//         // ✅ If it's HTML content, open a new tab and write it there
//         else {
//           const newWindow = window.open("", "_blank");
//           newWindow.document.write(result);
//           newWindow.document.close();
//         }

//       } else {
//         setLoading(false);
//         const errorMessages = [];
//         for (const key in response.errors) {
//           if (response.errors.hasOwnProperty(key)) {
//             const messages = response.errors[key];
//             errorMessages.push(...messages);
//           }
//         }
//         errorMessages.forEach((errorMessage) => {
//           toast.error(errorMessage, { position: "top-right" });
//         });
//       }
//     })
//     .catch((error) => {
//       console.error("Error:", error, "DataFormat:", formData);
//       toast.error("An unexpected error occurred.", {
//         position: "top-right",
//       });
//       setLoading(false);
//     });
// };


//   return (
//     <Modal show={showModal} onHide={handleCloseModal}>
//           <Modal.Header closeButton>
//             <Modal.Title>
//   Looks Like you're not registered!! <br />
//   Register to continue..
// </Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
            // <Formik>
            //   <Form>
            //     <div className="row">
            //       <div className="col-12 col-sm-12 col-md-6 col-lg-6">
            //         <div className="input-container">
            //           <TextBox
            //             isRequired={false}
            //             label={'Company Name'}
            //             name={'companyName'}
            //             placeholder={
            //               formData?.type === "view"
            //                 ? formData?.companyName || "--"
            //                 : formData?.companyName ||
            //               'Enter Company Name'
            //             }
            //             handleChange={handleChangeForm}
            //             value={formData?.companyName}
            //           />
            //         </div>
            //       </div>

                 

                 
            //       <div className="col-12 col-sm-12 col-md-6 col-lg-6">
            //         <div className="input-container">
            //           <TextBox
            //             isRequired={false}
            //             label={'Email Id'}
            //             name={'userEmailId'}
            //             placeholder={
            //               formData?.type === "view"
            //                 ? formData?.userEmailId || "--"
            //                 : formData?.userEmailId ||
            //               'Enter Email Id'
            //             }
            //             handleChange={handleChangeForm}
            //             value={formData?.userEmailId}
            //           />
            //         </div>
            //       </div>
            //     </div>
            //   </Form>
            // </Formik>
//           </Modal.Body>

//           <Modal.Footer>
//             <Button variant="secondary" 
//             onClick={handleCloseModal}
//             >
//               Cancel
//             </Button>
//             <Button
//               variant="success"
//               onClick={() => handleSubmit(formData)}
//               disabled={
//                 !formData?.userEmailId || !formData?.companyName
//               }
//             >
//               Submit
//             </Button>
//           </Modal.Footer>
//         </Modal>
//   )
// }

// export default CampaignRegistrationPopup

import React, { useState } from "react";
// import "./RegistrationPage.css";
import { Form, Formik } from "formik";
import sidelogo from '../../../src/assets/img/LeadTrack-logo.svg';
import { TextBox } from "../../shared/controls/form";
import { toast } from "react-toastify";
import apiServices from "../../services/service";

const CampaignRegistrationPopup = () => {
  const [formData, setFormData] = useState()
  const [loading, setLoading] = useState(false)

    const handleChangeForm = (e) => {
  const { name, value } = e.target;
  setFormData((prevData) => ({
    ...prevData,
    [name]: value,
  }));
};

  const handleSubmit = (formData) => {
  setLoading(true);
  apiServices
    .getAccessToken(formData)
    .then((response) => {
      if (response.status === 200) {
        setLoading(false);
        const result = response.data;

        // ✅ If it's a URL string, open it in a new tab
        if (typeof result === "string" && result.startsWith("http")) {
          window.open(result, "_blank");
        } 
        // ✅ If it's a file blob (like PDF), create a URL and open it
        else if (result instanceof Blob) {
          const blobUrl = URL.createObjectURL(result);
          window.open(blobUrl, "_blank");
        } 
        // ✅ If it's HTML content, open a new tab and write it there
        else {
          const newWindow = window.open("", "_blank");
          newWindow.document.write(result);
          newWindow.document.close();
        }

      } else {
        setLoading(false);
        const errorMessages = [];
        for (const key in response.errors) {
          if (response.errors.hasOwnProperty(key)) {
            const messages = response.errors[key];
            errorMessages.push(...messages);
          }
        }
        errorMessages.forEach((errorMessage) => {
          toast.error(errorMessage, { position: "top-right" });
        });
      }
    })
    .catch((error) => {
      console.error("Error:", error, "DataFormat:", formData);
      toast.error("An unexpected error occurred.", {
        position: "top-right",
      });
      setLoading(false);
    });
};

  return (
    <div className="container-fluid vh-100 p-0">
        <div className="row g-0 h-100">
          {/* Left Side - Registration Form */}
          <div className="col-lg-6 d-flex align-items-center justify-content-center" 
               style={{ 
                 background: '#ffffff',
                 minHeight: '100vh',
                 padding: '3rem'
               }}>
            <div style={{ maxWidth: '450px', width: '100%' }}>
              {/* Logo and Title */}
              <div className="mb-5">
                <h1 className="fw-bold mb-3" style={{ fontSize: '3rem', color: '#333', letterSpacing: '-1px' }}>
                  <span style={{ color: '#6f42c1' }}>L</span>eadTrack
                </h1>
                <h2 className="fw-bold mb-3" style={{ fontSize: '2.2rem', color: '#333', lineHeight: '1.2' }}>
                  Register Your Domain
                </h2>
                <p className="text-muted" style={{ fontSize: '1.1rem', marginBottom: '0' }}>
                  Let's get you started!
                </p>
              </div>

              {/* Registration Form */}
              <Formik>
                <Form>
                  <div className="row">
                    <div className="col-12">
                      <div className="input-container mb-4">
                        <TextBox
                          isRequired={false}
                          label={'Company Name'}
                          name={'companyName'}
                          placeholder={
                            formData?.type === "view"
                              ? formData?.companyName || "--"
                              : 'Enter Company Name'
                          }
                          handleChange={handleChangeForm}
                          value={formData?.companyName}
                        />
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="input-container mb-4">
                        <TextBox
                          isRequired={false}
                          label={'Email Id'}
                          name={'userEmailId'}
                          placeholder={
                            formData?.type === "view"
                              ? formData?.userEmailId || "--"
                              : 'Enter Email Id'
                          }
                          handleChange={handleChangeForm}
                          value={formData?.userEmailId}
                        />
                      </div>
                    </div>
                  </div>
                </Form>
              </Formik>

              <div className="mt-4">
                <button
                  type="button"
                  onClick={() => handleSubmit(formData)}
                  className="btn btn-lg w-100"
                  style={{
                    background: 'linear-gradient(135deg, #6f42c1, #563d7c)',
                    border: 'none',
                    borderRadius: '12px',
                    color: 'white',
                    fontWeight: '600',
                    padding: '1rem 2rem',
                    fontSize: '1.1rem',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 15px rgba(111, 66, 193, 0.2)'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 8px 25px rgba(111, 66, 193, 0.4)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 15px rgba(111, 66, 193, 0.2)';
                  }}
                >
                  Register
                </button>
              </div>
            </div>
          </div>

          {/* Right Side - Illustration */}
          <div className="col-lg-6 d-flex align-items-center justify-content-center position-relative" 
               style={{ 
                 background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
                 minHeight: '100vh'
               }}>
            
            {/* Background Decorative Elements */}
            <div className="position-absolute rounded-circle"
                 style={{
                   top: '10%',
                   left: '10%',
                   width: '80px',
                   height: '80px',
                   background: 'rgba(33, 150, 243, 0.2)'
                 }}>
            </div>
            <div className="position-absolute rounded-circle"
                 style={{
                   top: '25%',
                   right: '15%',
                   width: '60px',
                   height: '60px',
                   background: 'rgba(156, 39, 176, 0.2)'
                 }}>
            </div>
            <div className="position-absolute rounded-circle"
                 style={{
                   bottom: '20%',
                   left: '20%',
                   width: '50px',
                   height: '50px',
                   background: 'rgba(255, 152, 0, 0.2)'
                 }}>
            </div>

            {/* Main Content */}
            <div className="text-center" style={{ maxWidth: '500px', zIndex: 10 }}>
              {/* Dashboard Mockup */}
              <div className="bg-white rounded-4 shadow-lg p-4 mb-4 mx-auto" 
                   style={{ 
                     maxWidth: '400px',
                     transform: 'rotate(2deg)',
                     transition: 'transform 0.3s ease'
                   }}
                   onMouseOver={(e) => e.target.style.transform = 'rotate(0deg)'}
                   onMouseOut={(e) => e.target.style.transform = 'rotate(2deg)'}>
                
                {/* Dashboard Header */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="bg-success rounded-circle d-flex align-items-center justify-content-center" 
                       style={{ width: '32px', height: '32px' }}>
                    <div className="bg-white rounded-circle" style={{ width: '12px', height: '12px' }}></div>
                  </div>
                  <div className="d-flex gap-1">
                    <div className="bg-light rounded-circle" style={{ width: '8px', height: '8px' }}></div>
                    <div className="bg-light rounded-circle" style={{ width: '8px', height: '8px' }}></div>
                    <div className="bg-light rounded-circle" style={{ width: '8px', height: '8px' }}></div>
                  </div>
                </div>

                {/* Charts */}
                <div className="d-flex justify-content-center align-items-end gap-2 mb-3">
                  <div style={{
                    width: '60px',
                    height: '80px',
                    background: 'linear-gradient(to top, #2196f3, #64b5f6)',
                    borderRadius: '4px'
                  }}></div>
                  <div style={{
                    width: '60px',
                    height: '100px',
                    background: 'linear-gradient(to top, #9c27b0, #ba68c8)',
                    borderRadius: '4px'
                  }}></div>
                  <div style={{
                    width: '60px',
                    height: '60px',
                    background: 'linear-gradient(to top, #ff9800, #ffb74d)',
                    borderRadius: '4px'
                  }}></div>
                </div>

                {/* Pie Chart */}
                <div className="d-flex justify-content-center">
                  <div className="position-relative" style={{
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    background: 'conic-gradient(#ff9800 0deg 120deg, #9c27b0 120deg 240deg, #2196f3 240deg 360deg)'
                  }}>
                    <div className="position-absolute top-50 start-50 translate-middle bg-white rounded-circle"
                         style={{ width: '40px', height: '40px' }}>
                    </div>
                  </div>
                </div>
              </div>

              {/* People Illustration */}
              <div className="d-flex justify-content-center gap-4 mb-4">
                {/* Person 1 */}
                <div className="text-center">
                  <div className="mx-auto mb-2 d-flex align-items-center justify-content-center"
                       style={{
                         width: '50px',
                         height: '50px',
                         background: 'linear-gradient(135deg, #ff9800, #f57c00)',
                         borderRadius: '50%'
                       }}>
                    <div className="bg-white rounded-circle" style={{ width: '20px', height: '20px' }}></div>
                  </div>
                  <div className="mx-auto"
                       style={{
                         width: '35px',
                         height: '60px',
                         background: '#ff9800',
                         borderRadius: '20px 20px 0 0'
                       }}>
                  </div>
                </div>

                {/* Person 2 */}
                <div className="text-center">
                  <div className="mx-auto mb-2 d-flex align-items-center justify-content-center"
                       style={{
                         width: '50px',
                         height: '50px',
                         background: 'linear-gradient(135deg, #2196f3, #1976d2)',
                         borderRadius: '50%'
                       }}>
                    <div className="bg-white rounded-circle" style={{ width: '20px', height: '20px' }}></div>
                  </div>
                  <div className="mx-auto"
                       style={{
                         width: '35px',
                         height: '60px',
                         background: '#2196f3',
                         borderRadius: '20px 20px 0 0'
                       }}>
                  </div>
                </div>

                {/* Person 3 */}
                <div className="text-center">
                  <div className="mx-auto mb-2 d-flex align-items-center justify-content-center"
                       style={{
                         width: '50px',
                         height: '50px',
                         background: 'linear-gradient(135deg, #9c27b0, #7b1fa2)',
                         borderRadius: '50%'
                       }}>
                    <div className="bg-white rounded-circle" style={{ width: '20px', height: '20px' }}></div>
                  </div>
                  <div className="mx-auto"
                       style={{
                         width: '35px',
                         height: '60px',
                         background: '#9c27b0',
                         borderRadius: '20px 20px 0 0'
                       }}>
                  </div>
                </div>
              </div>

              {/* Text Content */}
              <div>
                <h3 className="h4 fw-bold text-dark mb-3">Unlock New Possibilities</h3>
                <p className="text-muted">
                  Discover solutions that help you move faster, work smarter, 
                  and achieve more. With the right tools and support, growth 
                  isn't just a goal—it's your reality.
                </p>
              </div>
            </div>

            {/* Additional Floating Elements */}
            <div className="position-absolute"
                 style={{
                   top: '30%',
                   right: '25%',
                   width: '25px',
                   height: '25px',
                   background: '#ffc107',
                   borderRadius: '6px',
                   opacity: '0.7'
                 }}>
            </div>
            <div className="position-absolute rounded-circle"
                 style={{
                   bottom: '40%',
                   right: '30%',
                   width: '20px',
                   height: '20px',
                   background: '#4caf50',
                   opacity: '0.7'
                 }}>
            </div>
          </div>
        </div>
      </div>
  );
};

export default CampaignRegistrationPopup;
